import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  ContratoDetailsState,
  ContratoDetailsAction,
  ContratoDetailsReducer,
} from './contrato-details-reducer';

const initialState: ContratoDetailsState = {
  contratoDetails: null,
  loading: false,
  error: null,
};

const ContratoDetailsStateContext = createContext<ContratoDetailsState | undefined>(undefined);
const ContratoDetailsDispatchContext = createContext<React.Dispatch<ContratoDetailsAction> | undefined>(undefined);

interface ContratoDetailsProviderProps {
  children: ReactNode;
}

export const ContratoDetailsProvider: React.FC<ContratoDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(ContratoDetailsReducer, initialState);

  return (
    <ContratoDetailsStateContext.Provider value={state}>
      <ContratoDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </ContratoDetailsDispatchContext.Provider>
    </ContratoDetailsStateContext.Provider>
  );
};

export const useContratoDetailsState = (): ContratoDetailsState => {
  const context = useContext(ContratoDetailsStateContext);
  if (context === undefined) {
    throw new Error('useContratoDetailsState must be used within a ContratoDetailsProvider');
  }
  return context;
};

export const useContratoDetailsDispatch = (): React.Dispatch<ContratoDetailsAction> => {
  const context = useContext(ContratoDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useContratoDetailsDispatch must be used within a ContratoDetailsProvider');
  }
  return context;
};
